import { ApexOptions } from 'apexcharts';
import { chartInfoInterface } from 'src/interfaces/Chart';
import { findPower, formatPowerForGraph } from 'src/Resources/formatPower';

export const getChartOptions = (
  chartInfo: chartInfoInterface,
  type: string,
  dateList: string[],
  stacked: Boolean,
  voltageInfo?: chartInfoInterface
): ApexOptions => {
  return type.includes('daily')
    ? {
        chart: {
          id: 'area-datetime',
          toolbar: {
            show: false
          },
          type: 'line',
          height: 350,
          zoom: {
            autoScaleYaxis: false
          }
        },

        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'solid'
        },

        colors: ['#3498db', '#2ecc71', '#282828'],
        xaxis: {
          type: 'datetime',
          tickAmount: 8,
          labels: {
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM 'yy",
              day: 'dd MMM',
              hour: 'HH:mm',
              minute: 'mm'
            }
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        grid: {
          padding: {
            top: 30
          }
        },
        yaxis:
          type === 'dailyoverview'
            ? [
                {
                  seriesName: 'Grid Power',
                  tickAmount: 6,
                  min:
                    chartInfo.min >= 0
                      ? 0
                      : chartInfo.max <= 0
                      ? Math.ceil(
                          chartInfo.min / findPower(chartInfo.min).value
                        ) * findPower(chartInfo.min).value
                      : undefined,
                  max:
                    chartInfo.min >= 0
                      ? Math.ceil(
                          chartInfo.max / findPower(chartInfo.max).value
                        ) * findPower(chartInfo.max).value
                      : chartInfo.max <= 0
                      ? 0
                      : undefined,
                  title: {
                    text: chartInfo.unit,
                    style: {
                      fontSize: '12px'
                    },
                    offsetY: -190,
                    offsetX: 25,
                    rotate: 0
                  },
                  labels: {
                    formatter: function (value: number) {
                      return formatPowerForGraph(
                        value,
                        chartInfo.magnitude
                      ).value.toString();
                    }
                  }
                },
                {
                  seriesName: 'Grid Power',
                  show: false,
                  tickAmount: 6,
                  min:
                    chartInfo.min >= 0
                      ? 0
                      : chartInfo.max <= 0
                      ? Math.ceil(
                          chartInfo.min / findPower(chartInfo.min).value
                        ) * findPower(chartInfo.min).value
                      : undefined,
                  max:
                    chartInfo.min >= 0
                      ? Math.ceil(
                          chartInfo.max / findPower(chartInfo.max).value
                        ) * findPower(chartInfo.max).value
                      : chartInfo.max <= 0
                      ? 0
                      : undefined,
                  labels: {
                    formatter: function (value: number) {
                      return formatPowerForGraph(
                        value,
                        chartInfo.magnitude
                      ).value.toString();
                    }
                  }
                },
                {
                  seriesName: 'Grid Power',
                  show: false,
                  tickAmount: 6,
                  min:
                    chartInfo.min >= 0
                      ? 0
                      : chartInfo.max <= 0
                      ? Math.ceil(
                          chartInfo.min / findPower(chartInfo.min).value
                        ) * findPower(chartInfo.min).value
                      : undefined,
                  max:
                    chartInfo.min >= 0
                      ? Math.ceil(
                          chartInfo.max / findPower(chartInfo.max).value
                        ) * findPower(chartInfo.max).value
                      : chartInfo.max <= 0
                      ? 0
                      : undefined,
                  labels: {
                    formatter: function (value: number) {
                      return formatPowerForGraph(
                        value,
                        chartInfo.magnitude
                      ).value.toString();
                    }
                  }
                },
                {
                  seriesName: 'Battery SOC',
                  opposite: true,
                  tickAmount: 5,
                  min: 0,
                  max: 100,
                  title: {
                    text: '(%)',
                    style: {
                      fontSize: '12px'
                    },
                    offsetY: -190,
                    offsetX: -25,
                    rotate: 0
                  },
                  labels: {
                    formatter: function (value: number) {
                      return Math.round(value).toString();
                    }
                  }
                },
                ...(voltageInfo ? [{
                  seriesName: 'Battery Voltage',
                  opposite: true,
                  tickAmount: 5,
                  min: voltageInfo.min > 0 ? Math.floor(voltageInfo.min / 5) * 5 : 0,
                  max: Math.ceil(voltageInfo.max / 5) * 5,
                  title: {
                    text: '(V)',
                    style: {
                      fontSize: '12px'
                    },
                    offsetY: -190,
                    offsetX: -45,
                    rotate: 0
                  },
                  labels: {
                    formatter: function (value: number) {
                      return Math.round(value).toString();
                    }
                  }
                }] : [])
              ]
            : {
                tickAmount: chartInfo.unit === '(%)' ? 5 : 6,
                min:
                  chartInfo.min >= 0
                    ? 0
                    : chartInfo.max <= 0
                    ? Math.ceil(
                        chartInfo.min / findPower(chartInfo.min).value
                      ) * findPower(chartInfo.min).value
                    : undefined,
                max:
                  chartInfo.min >= 0
                    ? Math.ceil(
                        chartInfo.max / findPower(chartInfo.max).value
                      ) * findPower(chartInfo.max).value
                    : chartInfo.max <= 0
                    ? 0
                    : undefined,
                title: {
                  text: chartInfo.unit,
                  style: {
                    fontSize: '12px'
                  },
                  offsetY: -190,
                  offsetX: 25,
                  rotate: 0
                },
                labels: {
                  formatter: function (value: number) {
                    if (chartInfo.unit === '(%)') {
                      return Math.round(value).toString();
                    }
                    return formatPowerForGraph(
                      value,
                      chartInfo.magnitude
                    ).value.toString();
                  }
                }
              },

        tooltip: {
          shared: true,
          x: {
            format: 'dd MMM HH:mm:ss'
          },
          y: {
            formatter: function (val, { seriesIndex, w }) {
              const seriesName = w.config.series[seriesIndex].name;
              if (seriesName === 'Battery SOC') {
                return val.toFixed(2) + ' %';
              } else if (seriesName === 'Battery Voltage') {
                return val.toFixed(2) + ' (V)';
              } else {
                return (
                  formatPowerForGraph(val, chartInfo.magnitude).value.toFixed(
                    2
                  ) +
                  ' ' +
                  chartInfo.unit
                );
              }
            }
          }
        }
      }
    : {
        chart: {
          height: 380,
          stacked: chartInfo.unit !== '(%)' && type != 'overview'
        },
        stroke: {
          width: [0, 0, 0, 2],
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            //If min<0 and max>0, then we have 2 stacked bars, one with positive and one with negative values, so each one of them should have border radius. \
            //Otherwise, we have a single bar or two stacked bars either with positive or negative values.
            borderRadius:
              stacked && chartInfo.min <= 0 && chartInfo.max > 0 ? [10] : 10,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: false,
          formatter: function (val) {
            return (
              formatPowerForGraph(val, chartInfo.magnitude).value.toFixed(2) +
              ' ' +
              chartInfo.unit
            );
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: dateList,
          position: 'bottom',

          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          tickAmount: 6,
          min:
            chartInfo.min >= 0
              ? 0
              : chartInfo.max <= 0
              ? Math.ceil(chartInfo.min / findPower(chartInfo.min).value) *
                findPower(chartInfo.min).value
              : Math.abs(chartInfo.min) < 1 || Math.abs(chartInfo.max) < 1
              ? -Math.max(
                  Math.abs(
                    Math.ceil(chartInfo.min / findPower(chartInfo.min).value) *
                      findPower(chartInfo.min).value
                  ),
                  Math.ceil(chartInfo.max / findPower(chartInfo.max).value) *
                    findPower(chartInfo.max).value
                ).toFixed(2)
              : undefined,
          max:
            chartInfo.min >= 0
              ? +(
                  Math.ceil(chartInfo.max / findPower(chartInfo.max).value) *
                  findPower(chartInfo.max).value
                ).toFixed(2)
              : chartInfo.max <= 0
              ? 0
              : Math.abs(chartInfo.min) < 1 || Math.abs(chartInfo.max) < 1
              ? +Math.max(
                  Math.abs(
                    Math.ceil(chartInfo.min / findPower(chartInfo.min).value) *
                      findPower(chartInfo.min).value
                  ),
                  Math.ceil(chartInfo.max / findPower(chartInfo.max).value) *
                    findPower(chartInfo.max).value
                ).toFixed(2)
              : undefined,
          title: {
            text: chartInfo.unit,
            style: {
              fontSize: '12px'
            },
            offsetY: type === 'monthly' ? -176 : -178,
            offsetX: 25,
            rotate: 0
          },
          labels: {
            formatter: function (value: number) {
              return formatPowerForGraph(value, 0).value.toString();
            }
          }
        },
        annotations: {
          yaxis: [
            {
              y: 0,
              strokeDashArray: 0,
              borderColor: '#d3d3d3',
              borderWidth: 1,
              yAxisIndex: 0
            }
          ]
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val < 1
                ? val.toFixed(3) + ' ' + chartInfo.unit
                : val.toFixed(2) + ' ' + chartInfo.unit;
            }
          }
        }
      };
};
